$(document).ready(function () {
    window.addEventListener('load', (event) => {
        var element = document.getElementsByClassName('js-clickToOpenTarget');
        for (var i = 0; i < element.length; i++) {
            element[i].addEventListener("click", function (e) {

                if (!e.target.classList.contains('Icon--share') && !e.target.classList.contains('socialMediaStopPropagation')) {
                    window.open(this.getAttribute('data-click-to-open-target'), '_blank');
                }

                if (e.target.classList.contains('Icon--share')) {
                    e.target.nextElementSibling.classList.toggle('hide');
                }
                else {
                    for (var item of document.querySelectorAll('.timeline-ShareMenu-container'))
                        item.classList.add('hide');
                }
            }, false);
        }
    });
});